import { lazy } from "react";

const create = lazy(() => import("./Create").then(m => ({ default: m.PersonWorkExperienceCreate })));
const edit = lazy(() => import("./Edit").then(m => ({ default: m.PersonWorkExperienceEdit })));

export default {
  create,
  edit,
  options: { label: "Person Work Experience" },
};
